module.exports = __webpack_public_path__ + "static/media/avatar_15.5d07a305.svg";